// src/components/AddAddress.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { getCartProducts } from "../../utils/cartUtils";
import { useNavigate } from "react-router-dom";

const AddAddress = ({ onBack, refreshAddresses }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobile_no: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    address_details: "",
    address_type: "Home",
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const user_auto_id = sessionStorage.getItem("accessToken");
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);
  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/add_user_address`,
        {
          ...formData,
          admin_auto_id,
          user_auto_id,
        }
      );
      if (res.data.status === "1") {
        setMessage("Address added successfully!");
        setMessageType("success");

        // fetch cart products
        const cartProducts = await getCartProducts();

        refreshAddresses?.();
        setTimeout(() => {
          setMessage("");
          if (Array.isArray(cartProducts) && cartProducts.length > 0) {
            navigate('/checkout');   // navigate to cart
          } else {
            onBack();                         // same old behavior
          }
          onBack();
        }, 2000);
      } else {
        setMessage(res.data.message || "Failed to add address");
        setMessageType("error");
        setTimeout(() => setMessage(""), 2000);
      }
    } catch (error) {
      console.error("Error adding address:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`p-6 ${webFont}`}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="flex items-center justify-between px-6 py-2 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h2 className="text-xl font-bold">
          Add New Address
        </h2>
      </div>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 gap-4 p-4 md:grid-cols-2 md:p-6"
      >
        {[
          ["Name", "name"],
          ["Mobile No", "mobile_no"],
          ["Area", "area"],
          ["City", "city"],
          ["State", "state"],
          ["Country", "country"],
          ["Pincode", "pincode"],
          ["Address Details", "address_details"],
        ].map(([label, name]) => (
          <div key={name} className="w-full">
            <label className="block mb-1 text-sm font-medium">{label}</label>

            <input
              name={name}
              value={formData[name]}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-sm border rounded md:text-base"
            />
          </div>
        ))}

        {/* Address Type — full width ONLY ON DESKTOP */}
        <div className="w-full md:col-span-2">
          <label className="block mb-1 text-sm font-medium">Address Type</label>

          <div className="flex gap-4">
            {["Home", "Work", "Other"].map((type) => (
              <label key={type} className="flex items-center gap-2">
                <input
                  type="radio"
                  name="address_type"
                  value={type}
                  checked={formData.address_type === type}
                  onChange={handleChange}
                />
                {type}
              </label>
            ))}
          </div>
        </div>

        {/* Buttons — full width ONLY ON DESKTOP */}
        <div className="relative w-full mt-4 md:col-span-2">
          <div className="flex justify-between">
            <button
              type="button"
              onClick={onBack}
              className="px-4 py-2 border border-gray-400"
            >
              Cancel
            </button>

            {message && (
              <span
                className={`absolute top-[-1.5rem] right-0 text-sm ${messageType === "success" ? "text-green-600" : "text-red-600"
                  }`}
              >
                {message}
              </span>
            )}

            <button
              type="submit"
              className="px-4 py-2 text-white"
              disabled={isSubmitting}
              style={{ backgroundColor: themeColor }}
            >
              {isSubmitting ? "Adding..." : "Add Address"}
            </button>
          </div>
        </div>
      </form>

    </div>
  );
};

export default AddAddress;
